import { View } from 'components/View'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'

export default function PressableRow ({
  onClick,
  style,
  direction,
  isSelected,
  children
}) {
  return (
    <View
      style={getStyleComponentUtil(
        {
          cursor: onClick
            ? 'pointer'
            : 'initial',
          width: '100%',
          borderRadius: '30px',
          border: isSelected
            ? '0.055em solid #0099e5'
            : '0.055em solid #e6e6e6',
          padding: '0.55em 1rem',
          boxSizing: 'border-box',
          textAlign: 'left',
          minHeight: '3.22em',
          alignItems: 'center',
          flexDirection: direction ||
            View.DIRECTION.ROW
        },
        style
      )}
      onClick={onClick}
    >
      {children}
    </View>
  )
}
